import React from "react";
import { Modal, ModalTitle, ModalBody, ModalFooter } from "@vds/modals";
import { useWindowSize } from "../../../../global/hooks/viewportHooks";
import { breakpoints } from "../../../../styles/breakpoints";
import {
  Cell,
  Table,
  TableBody,
  TableRow,
  TableHead,
  TableHeader,
} from "@vds/tables";
import {
  CreateAlertTitle,
  AlertNameFrameAndTimeFrame,
  SmallText,
  GreyTextField,
  ModalBaseLayout,
  ModalHeadingFrame,
  ModalContentFrame,
  InlineFlexRow,
  SeverityActionRow,
  SpanWithPadding,
  SpanWithLeftMargin,
} from "./stylesRoiModal";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Body, Typography } from "@vds/typography";
import { maxWidth, width } from "@mui/system";
import { Icon } from "@vds/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Input } from "@vds/inputs";
import {
  fetchRulesByDeviceIdSuccess,
  createRule,
  fetchRulesByDeviceIdRequest,
  fetchCountryIdsRequest,
} from "../../../../store/actions";
import {
  formatTimeFrame,
  formatTimeToBrowserTime,
  getLastSecThirdWords,
  getLastWord,
  getLocationByCamera,
  getLocationByTag,
  getTimeUnit,
  validateCondition,
} from "../../../utility/Utils";
import {
  getAlertEventInfo,
  getCustomerMessage,
  getcvAppImage,
  getCvAppTitle,
  getCVAppType,
  getLocationHierarchyWithIds,
} from "../../../utility/cvAppUtils";
import UniqueNameInput from "../../UniqueNameInput";
import { CV_APP_TYPE_EVENT } from "../../../constants/cvappConstants";

const AddExistingAlertModal = ({
  isModalOpen,
  closeRuleModal,
  cvApp,
  roiResponse,
  cvappid,
  roiid,
  fetchedRules,
  selectedOption,
  areaName,
  cameraId,
  expression,
  fovid,
  companionid,
  EEAppName,
  tagIds,
}) => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  const { cameraList } = useSelector((state) => state?.deviceReducer);
  const { width: viewportWidth } = useWindowSize();
  const isSmallScreen = (viewportWidth ?? 1400) < parseInt(breakpoints.tablet);
  const cvAppList = useSelector((state) => state.cvAppReducer.cvAppList);
  const headerStyle = {
    padding: isSmallScreen ? "0.75rem 0" : "2rem 0rem 2rem 0rem",
  };
  const sitesTagList = useSelector((state) => state.sitesReducer.siteTagList);
  const tagAllLists = useSelector((state) => state?.sitesReducer.tagIdList);
  const rulesLists = useSelector((state) => state.polygonRoiReducer.rulesData) || [];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [ruleName, setRuleName] = useState("");
  const [disableButton, setDisableButton] = useState(true);
  const [isError, setIsError] = useState(false);
  const [isValidAlertName, setIsValidAlertName] = useState(false);
  const alertList =
    useSelector((state) => state.polygonRoiReducer.rulesByDeviceId) || [];
  const fetched = useSelector((state) => state.polygonRoiReducer.fetched);
  const cvAppType = getCVAppType(cvAppList, cvappid);
  useEffect(() => {
    if (!fetched && !alertList.length) {
      dispatch(fetchRulesByDeviceIdRequest());
    }
  }, [dispatch, fetched, ruleName]);
  const ruleResponse = fetchedRules.find((rule) => rule.id === selectedOption);
  const contactGroups =
    ruleResponse?.contactGroup && ruleResponse?.contactGroup?.split(",");

  const dispatchWithPromise = () => {
    return new Promise((resolve) => {
      dispatch(fetchCountryIdsRequest(resolve));
    });
  };

  useEffect(() => {
    if (!sitesTagList || !tagAllLists) {
      dispatchWithPromise().then(() => { });
    }
  }, [tagAllLists, sitesTagList]);
  const submit = async () => {
    try {
      const updatedTagId =
        cvAppType === CV_APP_TYPE_EVENT
          ? getLocationByCamera(cameraId, cameraList)?.areaId
          : cvAppType !== CV_APP_TYPE_EVENT && tagIds && tagIds.length > 0
            ? Array.isArray(tagIds)
              ? tagIds[0]
              : tagIds
            : Array.isArray(ruleResponse?.tagid)
              ? ruleResponse?.tagId[0]
              : ruleResponse?.tagid;

      const updatedLocationHierarchy = getLocationHierarchyWithIds(
        sitesTagList,
        Array.isArray(updatedTagId) ? updatedTagId[0] : updatedTagId
      );
      const updatedLocationTag = getLocationByTag(
        tagAllLists,
        Array.isArray(updatedTagId) ? updatedTagId[0] : updatedTagId
      );
      let payload = {
        activeSession: activeSession,
        cvappid: cvappid,
        cvAppName: cvApp,
        severity: ruleResponse?.severity,
        timeFrame: ruleResponse?.timeFrame,
        groups: contactGroups,
        startTime: ruleResponse?.starttime,
        endTime: ruleResponse?.endtime,
        ruleName: ruleName,
        sms: ruleResponse?.sms,
        email: ruleResponse?.email,
        captureVideoEvidence: ruleResponse?.captureVideoEvidence ?? true,
        cameraId: cameraId,
        triggerData: {
          value: getLastWord(ruleResponse?.condition),
          time: getTimeUnit(ruleResponse?.duration),
        },
        showTimeFrame: ruleResponse?.showTimeFrame,
        condition: ruleResponse?.condition,
        expression: expression,
        fovid: fovid ? fovid : ruleResponse?.fovid,
        companionid: companionid,
        deploymentid: ruleResponse?.deploymentid,
        cvappImage: getcvAppImage(
          cvAppList,
          ruleResponse?.serviceid ? ruleResponse?.serviceid : cvappid
        ),
        customerMessage: getCustomerMessage(
          cvAppList,
          ruleResponse?.serviceid ? ruleResponse?.serviceid : cvappid
        ),
        title: getCvAppTitle(
          cvAppList,
          ruleResponse?.serviceid ? ruleResponse?.serviceid : cvappid
        ),
        aggregateRule: ruleResponse?.aggregateRule
          ? ruleResponse?.aggregateRule
          : false,
        tagid: updatedTagId,
        eventinfo: getAlertEventInfo(
          cvAppList,
          ruleResponse?.serviceid ? ruleResponse?.serviceid : cvappid,
          updatedLocationTag?.name,
          getLastWord(ruleResponse?.condition),
          getLastSecThirdWords(ruleResponse?.condition),
          ruleResponse?.duration ? ruleResponse?.duration : ""
        ),
        addUnits: ruleResponse?.addUnits ? ruleResponse?.addUnits : false,
        addCoolDownPeriod: ruleResponse?.addCoolDownPeriod
          ? ruleResponse?.addCoolDownPeriod
          : false,
        coolPeriodValue: ruleResponse?.coolPeriodValue,
        location: updatedLocationHierarchy,
        isEventApp: cvAppType === CV_APP_TYPE_EVENT ? true : false,
      };
      if (EEAppName) {
        payload.EEAppName = EEAppName;
      }
      if (roiid) {
        payload.roiid = roiid;
        dispatch(createRule(payload));
      } else {
        payload.action = "create";
        const updatedAlertList = Array.isArray(alertList) && alertList.length > 0
          ? [...alertList, payload]
          : [payload];
        dispatch(fetchRulesByDeviceIdSuccess(updatedAlertList));
      }
      if (ruleResponse?.addUnits === true) {
        payload.duration = ruleResponse?.duration;
      }
    } catch (error) {
      console.log("Getting error", error);
    }
  };

  const cancel = (event) => {
    console.log("Cancelled");
  };

  useEffect(() => {
    if (ruleName?.length > 0 && isValidAlertName) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  }, [ruleName, setRuleName]);

  return (
    <>
      <Modal
        opened={isModalOpen}
        surface="light"
        width={isSmallScreen ? "calc(100vw - 32px)" : "780px"}
        fullScreenDialog={isSmallScreen}
        disableAnimation={false}
        disableOutsideClick={false}
        ariaLabel="Testing Modal"
      >
        <ModalBaseLayout>
          <ModalHeadingFrame>
            <CreateAlertTitle>Add Alert</CreateAlertTitle>
          </ModalHeadingFrame>
          <ModalContentFrame>
            <AlertNameFrameAndTimeFrame>
              <SmallText>
                The settings from the existing alert below will be applied to
                this region of interest. Please name the alert for this region
                of interest.
              </SmallText>

              <UniqueNameInput
                label="Alert name"
                defaultValue={ruleName}
                data-testid="addExistingAlertModalRoiPolygonConfig_uniqueNameInput"
                onChange={(e) => {
                  setRuleName(e.target.value);
                }}
                error={isError}
                isError={isError}
                setIsError={setIsError}
                dataList={[...alertList, ...rulesLists]}
                setIsValid={setIsValidAlertName}
              />
            </AlertNameFrameAndTimeFrame>
          </ModalContentFrame>
        </ModalBaseLayout>
        <div style={isSmallScreen ? { overflowX: "auto", width: "100%" } : {}}>
          <div style={isSmallScreen ? { minWidth: "480px" } : {}}>
          <Table striped={false} surface="light" padding="standard">
            <TableHead>
              <TableHeader style={{ ...headerStyle, width: "10%" }}>
                Alert name
              </TableHeader>
              <TableHeader style={{ ...headerStyle, width: "10%" }}>
                Trigger
              </TableHeader>
              <TableHeader style={{ ...headerStyle, width: "10%" }}>
                Action
              </TableHeader>
            </TableHead>
            <TableBody>
              <TableRow>
                <Cell
                  style={{
                    width: "10%",
                    fontSize: "12px",
                    alignItems: "center",
                  }}
                >
                  <SpanWithLeftMargin>
                    {ruleResponse?.name}
                  </SpanWithLeftMargin>
                </Cell>
                <Cell style={{ width: "12%", fontSize: "12px" }}>
                  <InlineFlexRow>
                    <Icon name="reports-and-alerts" size="20px" color="#A7A7A7" />
                    <span>{ruleResponse?.condition}</span>
                  </InlineFlexRow>

                  <InlineFlexRow>
                    <Icon name="clock" size="20px" color="#A7A7A7" />
                    <span>
                      {ruleResponse?.timeFrame === "Always active" ||
                        ruleResponse?.timeFrame?.length == ""
                        ? "Always active"
                        : formatTimeFrame(
                          formatTimeToBrowserTime(
                            ruleResponse?.startTime
                              ? ruleResponse?.startTime
                              : ruleResponse?.starttime
                          ),
                          formatTimeToBrowserTime(
                            ruleResponse?.endTime
                              ? ruleResponse?.endTime
                              : ruleResponse?.endtime
                          ),
                          ruleResponse?.timeFrame
                        )}
                    </span>
                  </InlineFlexRow>
                </Cell>
                <Cell style={{ width: "20%", fontSize: "12px" }}>
                  <SeverityActionRow>
                    <GreyTextField bold size="small">
                      Severity:
                    </GreyTextField>
                    <SpanWithPadding>
                      {ruleResponse?.severity ? ruleResponse?.severity : "NA"}
                    </SpanWithPadding>
                  </SeverityActionRow>
                  <SeverityActionRow>
                    <GreyTextField bold size="small">
                      Groups:
                    </GreyTextField>
                    <SpanWithPadding>
                      {ruleResponse?.contactGroup
                        ? ruleResponse?.contactGroup
                        : "NA"}
                    </SpanWithPadding>
                  </SeverityActionRow>
                </Cell>
              </TableRow>
              {/* ))} */}
            </TableBody>
          </Table>
          </div>
        </div>

        <ModalFooter
          buttonData={{
            primary: {
              width: "350px",
              children: "Submit",
              disabled: disableButton,
              size: isSmallScreen ? "small" : "large",
              "data-testid":
                "addExistingAlertModalRoiPolygonConfig_submitButton",
              onClick: () => {
                submit();
              },
            },
            close: {
              width: "350px",
              children: "Cancel",
              size: isSmallScreen ? "small" : "large",
              "data-testid":
                "addExistingAlertModalRoiPolygonConfig_cancelButton",
              onClick: () => {
                cancel();
              },
            },
          }}
        />
      </Modal>
    </>
  );
};

export default AddExistingAlertModal;
